import { LayoutService } from './../../shared/layout/layout.service';
import { Injectable, NgZone } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { ApiResponse, ApiPagedResponse } from "app/client-core/api-response-models";
import { ApiService } from "../api.service";
import { CampaignThemeListItemDto, CampaignThemeCategoryLookupItemDto, CreateThemeCategoryCommand, SaveCampaignThemeCommand, CampaignThemeDto, CampaignThemeTacticListItemDto } from '../dtos/campaigns.model';
import { BrandListItemDto } from '../dtos/brands.model';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class NewCampaignService {

    constructor(
        private apiService: ApiService
    ) {

    }

    getCategories(params?: any): Observable<ApiResponse<ApiPagedResponse<CampaignThemeListItemDto>>> {
        console.log('>>getCategories', JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<CampaignThemeListItemDto>>('campaigns', params);
    }

    getAllCategories(params?: any): Observable<ApiResponse<ApiPagedResponse<CampaignThemeListItemDto>>> {
        console.log('>>getCategories', JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<CampaignThemeListItemDto>>('campaigns/all', params);
    }

    getMyCampaigns(params?: any, showLoading = true): Observable<ApiResponse<ApiPagedResponse<CampaignThemeListItemDto>>> {
        let headers: HttpHeaders = new HttpHeaders();
        headers = headers.append('showLoading', JSON.stringify(showLoading));
        console.log('>>getCategories', JSON.stringify(params));
        if (params) {
            for(const p in params) {
                if (!params[p]) {
                    delete params[p];
                }
            }
        }
        return this.apiService.get<ApiPagedResponse<CampaignThemeListItemDto>>('campaigns/MyCampaignsContainer', params, headers);
    }

    getCampaignThemeTactics(params?:any): Observable<ApiResponse<ApiPagedResponse<CampaignThemeTacticListItemDto>>> {
        console.log(`>>getCampaignThemeTactics for`, JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<CampaignThemeTacticListItemDto>>(`campaigns/campaign-theme-tactics`, params);
    }

    getCampaignTheme(id: number): Observable<ApiResponse<CampaignThemeDto>> {
        console.log(`>>getCampaignTheme for ${id}`);
        return this.apiService.get<CampaignThemeDto>(`campaigns/${id}`);
    }

    /**
     * Returns lookup list of projects
     * @param params
     */
    getThemeCategoryLookup(params?: any): Observable<ApiResponse<ApiPagedResponse<CampaignThemeCategoryLookupItemDto>>> {
        console.log('>>getThemeCategoryLookup', JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<CampaignThemeCategoryLookupItemDto>>('campaigns/lookup/theme-categories', params);
    }

    getBrandsLookup(params?: any): Observable<ApiResponse<ApiPagedResponse<BrandListItemDto>>> {
        console.log('>>getBrandsLookup', JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<BrandListItemDto>>('campaigns/lookup/brands', params);
    }

    getRoles(id?: any): Observable<any> {
        console.log('>>getBrandsLookup', JSON.stringify(id));
        return this.apiService.get<any>(`campaigns/getroles/${id}`);
    }

    getCustomizations(id?: any): Observable<any> {
        console.log('>>getBrandsLookup', JSON.stringify(id));
        return this.apiService.get<any>(`campaigns/getcustomizations/${id}`);
    }

    createThemeCategory(command: CreateThemeCategoryCommand): Observable<ApiResponse<number>> {
        return this.apiService.post<number>(`campaigns/theme-categories`, command);
    }

    createCampaignTheme(command: SaveCampaignThemeCommand): Observable<ApiResponse<number>> {
        return this.apiService.post<number>(`campaigns`, command);
    }

    updateCampaignTheme(id: number, command: SaveCampaignThemeCommand): Observable<ApiResponse<number>> {
        return this.apiService.post<number>(`campaigns/${id}`, command);
    }

    getMyCampaignsCalendar(params?: any): Promise<any> {
        console.log('>>campaigns calendar', JSON.stringify(params));
        return new Promise((resolve, reject) => {
            let headers: HttpHeaders = new HttpHeaders();
            headers = headers.append('showLoading', 'false');
            this.apiService.get<any>('campaigns/calendar', params, headers).subscribe(data => {
                resolve(data);
            }, err => {
                reject(err);
            });
        });
    }

    getMyCampaignsPromise(params?: any): Promise<ApiResponse<ApiPagedResponse<CampaignThemeListItemDto>>> {
        console.log('>>getCategories', JSON.stringify(params));
        let headers: HttpHeaders = new HttpHeaders();
        headers = headers.append('showLoading', 'false');
        return new Promise((resolve, reject) => {
            return this.apiService
                        .get<ApiPagedResponse<CampaignThemeListItemDto>>('campaigns/calendar', params, headers)
                        .subscribe(response => {
                            resolve(response);
                        }, error => {
                            reject(error);
                        });
        });
    }

    archiveProgram(id: number) {
        return this.apiService.put<number>(`programs/archive/${id}`, {});
    }

    getCampaignThemeTypes(params?: any): Observable<ApiResponse<ApiPagedResponse<{id: number, name: string}>>> {
        console.log('>>campaign-theme-type', JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<BrandListItemDto>>('campaigns/campaign-theme-type', params);
    }

    getStoredCalendar() {
        const calendar = localStorage.getItem('calendar_events');
        if (calendar) {
            return JSON.parse(calendar);
        }
        return null;
    }

    getStoredCalendarOriginalEvents() {
        const calendar = localStorage.getItem('calendar_original_itens');
        if (calendar) {
            return JSON.parse(calendar);
        }
        return null;
    }

    getProgramOverview(params?: any): Observable<ApiResponse<any>> {
        return this.apiService.get<any>('programs/overview', params);
    }

    getProgramOverviewDetails(params?: any): Observable<ApiResponse<any>> {
        return this.apiService.get<any>('programs/overview-details', params);
    }

    getProgramsDraft(params?: any): Observable<ApiResponse<any>> {
        return this.apiService.get<any>('programs/draft', params);
    }

    setCampaignThemeId(programId: number, campaignThemeId: number): Observable<ApiResponse<any>> {
        return this.apiService.put<any>(`programs/${programId}/set-campaignthemeid/${campaignThemeId}`, {});
    }
}



// WEBPACK FOOTER //
// ./src/app/client-core/services/new-campaign-service.ts